import { PacketValueSerialType } from "../../../enum/PacketValueSerialType";
import { Input, KeyCode } from "../../../lib/Input";
import { Physics } from "../../../math/Physics";
import Ability from "../../Ability";
import Player from "../../Player";

export default class TargetLock extends Ability {
    target: Player|undefined;

    constructor(player: Player) {
        super(player, {
            cooldown: 15,
            duration: 20,
            energyCost: 20,
            icon: 7,
            trigger: KeyCode.Digit2,
            triggerType: Input.GetKeyUp,
            info: `Target Lock (15s cooldown) - Reveal an enemy under your cursor to your team for 20 seconds`
        })
    }

    onDurationEnd(): void {
        if (!this.target) return;

        this.player.engine.sendUpdatePacket(this.target, "PLAYER", [
            {
                key: "isMarked",
                value: false,
                type: PacketValueSerialType.Bool
            }
        ]);
    }

    onUse(): void {
        const validPlayers = this.player.engine.GetGameObjectsBehaviors<Player>(Player).filter(
            v => !v.isDead && v.team && v.team !== this.player.team
        );

        for (const player of validPlayers) {
            if (Physics.CircleCircleCollision({
                position: this.player.engine.mouseWorldPosition,
                radius: 32
            }, {
                position: player.transform.position,
                radius: player.size
            }) !== false) {
                this.target = player;
                this.player.engine.sendUpdatePacket(this.target, "PLAYER", [
                    {
                        key: "isMarked",
                        value: true,
                        type: PacketValueSerialType.Bool
                    }
                ]);
                return;
            }
        }

        //nothing was hit.. refund?
        this.player.energy += this.energyCost;
        this.cooldownTimer = 0;
        this.durationTimer = 0;
    }

    onKeydownDraw(): void {
        const ctx = this.player.ctx;
        const engine = this.player.engine;

        ctx.fillStyle = '#55ff5530';
        engine.FillCircle(engine.mouseWorldPosition, 32);
    }
}